var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_18468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74672 3.24538L7.94938 2.44214L2.50781 7.92399H2.5645C2.75722 7.92399 2.94994 8.00774 3.11243 8.14478C3.24847 8.28183 3.33161 8.47598 3.33161 8.69677V8.75388L8.74672 3.24538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26197 7.45588L7.59395 2.08444L6.98933 1.47534L1.57422 6.92673C1.76694 6.92673 1.92943 7.01048 2.06925 7.14753C2.15239 7.23128 2.23552 7.34168 2.26197 7.45208",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.444845 10.113L0.199219 11L1.07969 10.7526C1.05324 10.5851 0.970108 10.448 0.86052 10.3376C0.750933 10.2272 0.614894 10.1435 0.448624 10.1168",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 1.83308L9.35237 0.47785C9.15964 0.283702 8.94047 0.199951 8.69484 0.199951C8.44922 0.199951 8.19981 0.310349 8.03732 0.47785L7.40625 1.11359L10.1006 3.82787L10.7317 3.19213C10.9244 2.99798 11.0075 2.77718 11.0075 2.52593C10.9811 2.24803 10.8715 2.00059 10.7052 1.83308",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74414 8.94811C3.85373 8.97476 3.96331 9.05851 4.04645 9.14226C4.18249 9.2793 4.26562 9.4468 4.26562 9.64095L9.68074 4.18575L9.07612 3.57666L3.74414 8.94811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5808 9.33634H3.14245C3.05931 9.33634 3.00641 9.30969 2.94972 9.25259C2.89304 9.19548 2.86659 9.11554 2.86659 9.05844V8.61684C2.86659 8.53309 2.84014 8.4798 2.78345 8.42269C2.72677 8.36559 2.64742 8.33894 2.59073 8.33894H2.15238C2.06925 8.33894 2.01634 8.3123 1.95966 8.25519C1.90298 8.19809 1.87653 8.1448 1.87653 8.06104V7.61945C1.87653 7.5357 1.85007 7.48241 1.79339 7.4253C1.74049 7.3682 1.65735 7.34155 1.60067 7.34155H1.16232L0.53125 9.69418C0.776876 9.74747 0.999829 9.86168 1.16232 10.0558C1.32859 10.2195 1.46463 10.4441 1.52131 10.6916L3.85665 10.0558V9.61043C3.85665 9.52668 3.8302 9.47338 3.77352 9.41628C3.71683 9.35918 3.63748 9.33253 3.5808 9.33253",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_18468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.8,
    fill: "white",
    transform: "translate(0.199219 0.199951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.09a2d1d99500a368be41820fb45b5d1f.svg";
export { ForwardRef as ReactComponent };